"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputDateBehavior = void 0;
var bc_calendar_behavior_1 = require("./bc-calendar-behavior");
var bc_date_constants_1 = require("./bc-date-constants");
var bc_date_constants_2 = require("./bc-date-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var common_constants_2 = require("../../../common/constants/common-constants");
var bc_abstract_dropdown_behavior_1 = require("../../molecules/bc-dropdown/bc-abstract-dropdown-behavior");
var bc_abstract_dropdown_constants_1 = require("../../molecules/bc-dropdown/bc-abstract-dropdown-constants");
var index_1 = require("../../../common/helpers/index");
var bc_calendar_behavior_utilities_1 = require("./bc-calendar-behavior-utilities");
var bc_input_constants_1 = require("../../molecules/bc-input/bc-input-constants");
var bc_input_constants_2 = require("../../molecules/bc-input/bc-input-constants");
var bc_input_constants_3 = require("../../molecules/bc-input/bc-input-constants");
var bc_date_constants_3 = require("./bc-date-constants");
var bc_date_constants_4 = require("./bc-date-constants");
var bc_date_constants_5 = require("./bc-date-constants");
var bc_date_constants_6 = require("./bc-date-constants");
var bc_date_constants_7 = require("./bc-date-constants");
var bc_date_constants_8 = require("./bc-date-constants");
var bc_date_constants_9 = require("./bc-date-constants");
var BcInputDateBehavior = (function (_super) {
    __extends(BcInputDateBehavior, _super);
    function BcInputDateBehavior() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bcInputDateUtilities = new bc_calendar_behavior_utilities_1.BcCalendarUtilities();
        return _this;
    }
    BcInputDateBehavior.setUpAll = function () {
        var inputDateElements = Array.from(document.querySelectorAll(".".concat(bc_date_constants_1.BcDateConstants.DATE_INPUT_DATE_CLASS)));
        var elements = [];
        for (var _i = 0, inputDateElements_1 = inputDateElements; _i < inputDateElements_1.length; _i++) {
            var element = inputDateElements_1[_i];
            var inputDateElement = new BcInputDateBehavior();
            inputDateElement.setElement(element);
            inputDateElement.setUp();
            elements.push(inputDateElement);
        }
        return elements;
    };
    BcInputDateBehavior.prototype.setUpSplitCalendar = function () {
        this.mySelf.setAttribute('type', bc_date_constants_1.BcDateConstants.STATE_SPLIT);
    };
    BcInputDateBehavior.prototype._setUp = function () {
        this.initializeElements();
        this.handleDateInput();
        this.createCalendarWrapper();
        this.initializeCalendarBehavior();
        this.setupAttributesAndTexts();
        this.configDropDown();
        this.addListeners();
        this.setAccesibility();
    };
    BcInputDateBehavior.prototype.initializeElements = function () {
        this.dropDownId = (0, index_1.getId)(BcInputDateBehavior);
        this.inputDate = this.mySelf.querySelector('input');
        var inputArrow = Array.from(this.mySelf.querySelectorAll(':scope div.bc-form-field em'));
        this.inputArrow = inputArrow[inputArrow.length - 1];
    };
    BcInputDateBehavior.prototype.handleDateInput = function () {
        if (this.inputDate.type === bc_date_constants_1.BcDateConstants.INPUT_TYPE_DATE) {
            this.inputDate.style.cursor = common_constants_1.BcCommonConstants.CURSOR_POINTER;
            if (this.checkIos()) {
                this.inputDate.classList.add(bc_date_constants_1.BcDateConstants.BC_INPUT_DATE_IOS_CLASS);
                this.inputDate.disabled = true;
                this.placeholderInput = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
                this.placeholderInput.classList.add(bc_date_constants_1.BcDateConstants.BC_INPUT_PLACEHOLDER_IOS);
                this.mySelf.appendChild(this.placeholderInput);
                this.placeholderInput.append(bc_date_constants_1.BcDateConstants.PLACEHOLDER_IOS);
            }
        }
    };
    BcInputDateBehavior.prototype.createCalendarWrapper = function () {
        this.wrapperCalendar = document.createElement('div');
        var calendar = document.createElement('div');
        this.wrapperCalendar.setAttribute('id', this.dropDownId);
        this.wrapperCalendar.classList.add(bc_abstract_dropdown_constants_1._DROPDOWN_CONTENT_CLASS);
        calendar.classList.add(bc_date_constants_1.BcDateConstants.CALENDAR_CLASS);
        this.setCalendarAttributes(calendar);
        this.wrapperCalendar.appendChild(calendar);
        this.calendarElement = calendar;
        this.mySelf.appendChild(this.wrapperCalendar);
    };
    BcInputDateBehavior.prototype.setCalendarAttributes = function (calendar) {
        calendar.setAttribute('type', this.mySelf.getAttribute('type'));
        calendar.setAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_BUTTON, this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_BUTTON));
        calendar.setAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_FILTER, this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_FILTER));
        calendar.setAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_HOLIDAY, this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_HOLIDAY));
        calendar.setAttribute('language', this.mySelf.getAttribute('language'));
        calendar.setAttribute('disabledMonths', this.mySelf.getAttribute('disabledMonths'));
        calendar.setAttribute('disabledDates', this.mySelf.getAttribute('disabledDates'));
        calendar.setAttribute('disabledYears', this.mySelf.getAttribute('disabledYears'));
    };
    BcInputDateBehavior.prototype.initializeCalendarBehavior = function () {
        var calendarBehavior = new bc_calendar_behavior_1.BcCalendarBehavior();
        this.calendarUtilities = new bc_calendar_behavior_utilities_1.BcCalendarUtilities();
        this.setupMinAndMaxDate();
        this.language = this.mySelf.getAttribute('language') == null ? 'es' : this.mySelf.getAttribute('language');
        this.originalIcon = this.inputArrow.innerHTML;
        calendarBehavior.setElement(this.calendarElement);
        calendarBehavior.setUp();
        this.calendarBehavior = calendarBehavior;
    };
    BcInputDateBehavior.prototype.setupAttributesAndTexts = function () {
        if (this.mySelf.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG)) {
            this.helpText = this.mySelf.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG).innerHTML;
        }
        else {
            this.helpText = '';
        }
        this.erroText = this.mySelf.getAttribute(bc_date_constants_6.ERROR_TEXT);
        this.successText = this.mySelf.getAttribute(bc_date_constants_7.SUCCESS_TEXT);
        this.validateInput = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.VALIDATE_INPUT) === 'true';
    };
    BcInputDateBehavior.prototype.setupMinAndMaxDate = function () {
        var min = this.mySelf.getAttribute('min');
        var max = this.mySelf.getAttribute('max');
        if (min) {
            this.calendarElement.setAttribute('min', min);
        }
        if (max) {
            this.calendarElement.setAttribute('max', max);
        }
    };
    BcInputDateBehavior.prototype.configDropDown = function () {
        var toogle = document.createElement('div');
        toogle.setAttribute('aria-controls', this.dropDownId);
        toogle.classList.add(bc_abstract_dropdown_constants_1._DROPDOWN_TOGGLE_CLASS);
        toogle.style.display = common_constants_1.BcCommonConstants.NONE;
        this.mySelf.appendChild(toogle);
        this.mySelf.classList.add(bc_abstract_dropdown_constants_1._DROPDOWN_CLASS);
        var dropDowConfig = {
            toggleEvents: ['click', 'focus'],
            extraToggles: [
                {
                    node: this.inputDate,
                    events: ['focus']
                }
            ],
            static: true,
            isPopUp: false,
            isDisabled: false,
            parentWidth: true,
            contentAutoWidth: true,
            maxHeightContent: this.maxHeightContent
        };
        this.setDropdownContentPosition();
        this.setConfig(dropDowConfig);
        _super.prototype._setUp.call(this);
    };
    BcInputDateBehavior.prototype.addListeners = function () {
        this.eventCalendar();
        this.eventFocusOut();
        this.eventClick();
        this.eventKeyPress();
        this.eventInpuntDate();
        this.addListenerWIndow();
    };
    BcInputDateBehavior.prototype.addListenerWIndow = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this._closeCalendarSimpleOutside();
        });
    };
    BcInputDateBehavior.prototype._closeCalendarSimpleOutside = function () {
        var _a;
        var parentElement = (_a = this.mySelf) === null || _a === void 0 ? void 0 : _a.getElementsByClassName(bc_abstract_dropdown_constants_1._DROPDOWN_CONTENT_ACTIVE_CLASS)[0];
        var input = document.querySelector(".".concat(bc_abstract_dropdown_constants_1._DROPDOWN_ACTIVE_CLASS));
        if (parentElement && input) {
            this.closeDropdownOutsideElement([parentElement, input]);
        }
    };
    BcInputDateBehavior.prototype.validateFocusoutValue = function (input) {
        if (input.value !== '') {
            var _a = input.value.split('-').map(Number), year = _a[0], month = _a[1], day = _a[2];
            var localDate = new Date(year, month - 1, day);
            if (!Number(year) && !Number(month)) {
                return;
            }
            this.calendarBehavior.date = localDate;
            this.calendarBehavior.updateDisplayedMonths(month - 1, year, day);
            var element = document.querySelector("#".concat(bc_date_constants_1.BcDateConstants.ID_DAY).concat(day, "[month=\"").concat(month - 1, "\"][year=\"").concat(year, "\"]"));
            if (element) {
                element.classList.add(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS);
            }
        }
    };
    BcInputDateBehavior.prototype.setAccesibility = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                _this.closeDropdown();
            }
        });
    };
    BcInputDateBehavior.prototype.eventInpuntDate = function () {
        var _this = this;
        this.inputArrow.style.cursor = common_constants_1.BcCommonConstants.CURSOR_POINTER;
        this.inputDate.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
            _this.handleClick(e);
        });
        this.inputDate.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUSOUT, function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                e.preventDefault();
                this.inputDate.classList.remove(bc_date_constants_4.ACTIVE_CLASS_INPUT);
                if (this.inputDate.type == 'date') {
                    this.setInputDateValue(e.target.value);
                }
                else {
                    this.inputDateFocusout(e);
                }
                return [2];
            });
        }); });
        this.inputDate.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
                event.preventDefault();
                var dropdownActive = _this.validateDropdownIsActive();
                if (!dropdownActive) {
                    _this.openDrowndown();
                    _this.validateMobileDropdown();
                }
                else {
                    _this.closeDropdown();
                }
                _this.setInputDateValue(event.target.value);
            }
        });
        this.inputArrow.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
            _this.inputRowClick(e);
            _this.inputDate.focus();
        });
        this.calendarElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CANCEL, function (e) {
            _this.closeDropdown();
        });
    };
    BcInputDateBehavior.prototype.validateMobileDropdown = function () {
        var dropdownActive = this.mySelf.getElementsByClassName(bc_date_constants_8.DROPDOWN_CONTENT_ACTIVE)[common_constants_2.COMMON_CONSTANTS_NUMBERS.N0];
        if (this.bcInputDateUtilities.maxScreenWidth() && dropdownActive) {
            dropdownActive.style.zIndex = "".concat(bc_date_constants_9.Z_INDEX_DROPDOWN_MOBILE);
        }
    };
    BcInputDateBehavior.prototype.inputRowClick = function (e) {
        if (this.validateInput) {
            if (this.inputArrow.innerHTML == bc_input_constants_3.BC_INPUT_REMOVE_ICON) {
                this.setDefaultStatusInput(true);
            }
            else {
                this.handleClick(e);
            }
        }
        else {
            this.handleClick(e);
        }
    };
    BcInputDateBehavior.prototype.inputDateFocusout = function (e) {
        var _this = this;
        requestAnimationFrame(function () {
            var dropdownActive = _this.validateDropdownIsActive();
            if (_this.inputDate.value == '' &&
                (_this.inputDate.classList.contains(bc_input_constants_2.INPUT_ERROR_CLASS) ||
                    _this.inputDate.classList.contains(bc_input_constants_1.INPUT_SUCCESS_CLASS))) {
                if (!dropdownActive) {
                    _this.setDefaultStatusInput(false);
                }
            }
            if (_this.inputDate.value == '' && !_this.inputDate.classList.contains(bc_input_constants_2.INPUT_ERROR_CLASS)) {
                _this.inputDate.classList.remove(bc_date_constants_4.ACTIVE_CLASS_INPUT);
                return;
            }
            _this.transformationDate(e.target.value);
        });
    };
    BcInputDateBehavior.prototype.eventCalendar = function () {
        var _this = this;
        this.calendarElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_SELECT, function (e) {
            e.preventDefault();
            if (_this.inputDate.type == 'date') {
                _this.setInputDateValue(e.detail);
            }
            else {
                _this.transformationDate(e.detail);
            }
            _this.closeDropdown();
        });
    };
    BcInputDateBehavior.prototype.validateSeparator = function (textInput) {
        if (textInput.includes('/')) {
            return '/';
        }
        else if (textInput.includes('-')) {
            return '-';
        }
        else if (textInput.includes(' ')) {
            return ' ';
        }
    };
    BcInputDateBehavior.prototype.transformationDate = function (date) {
        var formatDate = this.inputDate.getAttribute('formatdate');
        if (formatDate == bc_date_constants_2.DateFormate.fullDate) {
            this.validateMinMax(bc_date_constants_3.BcInputDateConstants.full, date);
        }
        else if (formatDate == bc_date_constants_2.DateFormate.mediumDate) {
            var resultDateMedium = this.verifyContentDate(date);
            this.validateMinMax(bc_date_constants_3.BcInputDateConstants.medium, resultDateMedium);
        }
        else if (formatDate == bc_date_constants_2.DateFormate.shortDate) {
            this.verifyYears(date);
        }
        else if (formatDate == null) {
            this.validateMinMax(bc_date_constants_3.BcInputDateConstants.full, date);
        }
    };
    BcInputDateBehavior.prototype.verifyYears = function (year) {
        var min = Number(this.mySelf.getAttribute('min'));
        var max = Number(this.mySelf.getAttribute('max'));
        if (Number(year) <= max && Number(year) >= min) {
            this.validateInputStatus(false);
            this.setInputDateValue(year);
        }
        else {
            this.validateInputStatus(true);
            this.setInputDateValue(year);
        }
    };
    BcInputDateBehavior.prototype.verifyContentDate = function (date) {
        if (date.includes(bc_date_constants_3.BcInputDateConstants.ofDate)) {
            return date.replace("".concat(bc_date_constants_3.BcInputDateConstants.ofDate, " "), '');
        }
        else {
            return date;
        }
    };
    BcInputDateBehavior.prototype.buildDateToFormted = function (target, language) {
        var separator = this.validateSeparator(target);
        var arrayDateSeparate = target.split(separator);
        var _a = this.verifyMonthsIndex(arrayDateSeparate, language), arrayDateSeparateMonth = _a.arrayDateSeparateMonth, validateIndex = _a.validateIndex;
        var newDate;
        if (arrayDateSeparateMonth.length == 1 || arrayDateSeparateMonth.filter(function (date) { return date == ''; }).length) {
            return;
        }
        else {
            if (arrayDateSeparateMonth.length > bc_date_constants_5.YEAR_INDEX) {
                if (validateIndex) {
                    newDate = this.bcInputDateUtilities.formatDate(arrayDateSeparateMonth[1], arrayDateSeparateMonth[0], arrayDateSeparateMonth[bc_date_constants_5.YEAR_INDEX], 'dd/MM/yyyy');
                }
                else {
                    newDate = this.bcInputDateUtilities.formatDate(arrayDateSeparateMonth[0], arrayDateSeparateMonth[1], arrayDateSeparateMonth[bc_date_constants_5.YEAR_INDEX], 'dd/MM/yyyy');
                }
            }
            else {
                newDate = this.bcInputDateUtilities.formatDate(arrayDateSeparateMonth[0], bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N28, arrayDateSeparateMonth[1], 'yyyy/MM/dd');
                var dateMonth = new Date(newDate);
                if (dateMonth.toString() == 'Invalid Date') {
                    newDate = this.bcInputDateUtilities.formatDate(arrayDateSeparateMonth[1], '1', arrayDateSeparateMonth[0], 'MM/dd/yyyy');
                }
            }
            var dateResult = new Date(newDate);
            if (dateResult.toString() == 'Invalid Date') {
                newDate = this.bcInputDateUtilities.formatDate(arrayDateSeparateMonth[1], arrayDateSeparateMonth[0], arrayDateSeparateMonth[bc_date_constants_5.YEAR_INDEX], 'dd/MM/yyyy');
                dateResult = new Date(newDate);
            }
            return { dateResult: dateResult, newDate: newDate };
        }
    };
    BcInputDateBehavior.prototype.verifyMonthsIndex = function (arrayDateSeparateMonth, language) {
        var calendarUtilities = new bc_calendar_behavior_utilities_1.BcCalendarUtilities();
        var indexZero;
        for (var i = 0; i < arrayDateSeparateMonth.length; i++) {
            var isNumber = Number(arrayDateSeparateMonth[i]);
            if (isNaN(isNumber)) {
                if (arrayDateSeparateMonth[i].length == common_constants_2.COMMON_CONSTANTS_NUMBERS.N3) {
                    indexZero = i;
                    arrayDateSeparateMonth[i] = String(calendarUtilities.getMonthShorIndex(arrayDateSeparateMonth[i], language) + 1);
                }
                else {
                    indexZero = i;
                    arrayDateSeparateMonth[i] = String(calendarUtilities.getMonthIndex(arrayDateSeparateMonth[i], language) + 1);
                }
            }
        }
        var validateIndex = this.validateIndex(indexZero);
        return { arrayDateSeparateMonth: arrayDateSeparateMonth, validateIndex: validateIndex };
    };
    BcInputDateBehavior.prototype.validateIndex = function (index) {
        if (index == 0) {
            return true;
        }
        else {
            return false;
        }
    };
    BcInputDateBehavior.prototype.validateMinMax = function (type, target) {
        try {
            var _a = this.buildDateToFormted(target, this.language), dateResult = _a.dateResult, newDate = _a.newDate;
            if (dateResult) {
                this.verifyMaxAndMin(newDate, type, dateResult);
            }
            else {
                this.validateInputStatus(true);
            }
        }
        catch (error) {
            this.validateInputStatus(true);
        }
    };
    BcInputDateBehavior.prototype.verifyMaxAndMin = function (newDate, type, dateResult) {
        var minDate = new Date(this.mySelf.getAttribute('min'));
        var maxDate = new Date(this.mySelf.getAttribute('max'));
        minDate.setUTCHours(common_constants_2.COMMON_CONSTANTS_NUMBERS.N0, common_constants_2.COMMON_CONSTANTS_NUMBERS.N0, common_constants_2.COMMON_CONSTANTS_NUMBERS.N0, common_constants_2.COMMON_CONSTANTS_NUMBERS.N0);
        maxDate.setUTCHours(bc_date_constants_1.BcDateConstants.NUMBERS.HOURS_N23, bc_date_constants_1.BcDateConstants.NUMBERS.MINUTES_AND_SECONDS_N59, bc_date_constants_1.BcDateConstants.NUMBERS.MINUTES_AND_SECONDS_N59, bc_date_constants_1.BcDateConstants.NUMBERS.MILISECONDS_N999);
        var min = minDate.getTime();
        var max = maxDate.getTime();
        var result = Date.parse(newDate);
        if (this.mySelf.getAttribute('min') && this.mySelf.getAttribute('max') && this.validateInput) {
            if (result <= max && result >= min) {
                this.validateType(type, dateResult);
            }
            else {
                this.validateInputStatus(true);
            }
        }
        else {
            this.validateType(type, dateResult);
        }
    };
    BcInputDateBehavior.prototype.validateType = function (type, dateResult) {
        if (type == 'medium') {
            this.updateDateMediumType(dateResult);
        }
        else {
            this.updateDateFullType(dateResult);
        }
    };
    BcInputDateBehavior.prototype.validateInputStatus = function (statusUpdate) {
        if (this.validateInput) {
            this.validatestatusInput(statusUpdate);
        }
        else {
            this.inputDate.classList.add(bc_date_constants_4.ACTIVE_CLASS_INPUT);
        }
    };
    BcInputDateBehavior.prototype.updateDateFullType = function (dateResult) {
        var formatedDate = this.calendarBehavior.dateToStringFormat(dateResult);
        this.inputDate.value = formatedDate;
        this.setInputDateValue(formatedDate);
        this.validateInputStatus(false);
    };
    BcInputDateBehavior.prototype.updateDateMediumType = function (dateResult) {
        this.calendarBehavior.date = dateResult;
        var dateFormatMonthAndYear = this.calendarBehavior.dateFormatMonthAndYear();
        this.inputDate.value = dateFormatMonthAndYear;
        this.setInputDateValue(dateFormatMonthAndYear);
        this.validateInputStatus(false);
    };
    BcInputDateBehavior.prototype.setDefaultStatusInput = function (withFocus) {
        this.bcInputDateUtilities.removeClassInput(this.inputDate);
        this.verifySpanInput();
        this.inputDate.value = '';
        if (withFocus) {
            this.inputDate.focus();
        }
        this.inputDate.classList.remove(bc_date_constants_4.ACTIVE_CLASS_INPUT);
        this.inputArrow.innerHTML = this.originalIcon;
    };
    BcInputDateBehavior.prototype.setDefaultStatusInputClass = function () {
        this.bcInputDateUtilities.removeClassInput(this.inputDate);
        this.verifySpanInput();
        this.inputArrow.innerHTML = this.originalIcon;
    };
    BcInputDateBehavior.prototype.setErrorStatusInputClass = function () {
        this.calendarUtilities.errorInputUpdateClass(this.inputDate, this.erroText, this.calendarBehavior);
    };
    BcInputDateBehavior.prototype.verifySpanInput = function () {
        if (this.inputDate.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG)) {
            var span = this.inputDate.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            span.innerHTML = this.helpText;
        }
    };
    BcInputDateBehavior.prototype.validatestatusInput = function (error) {
        if (error) {
            this.inputDate.classList.add(bc_date_constants_4.ACTIVE_CLASS_INPUT);
            this.bcInputDateUtilities.errorInputUpdateClass(this.inputDate, this.erroText, this.calendarBehavior);
        }
        else {
            this.inputDate.classList.add(bc_date_constants_4.ACTIVE_CLASS_INPUT);
            this.setDefaultStatusInputClass();
        }
    };
    BcInputDateBehavior.prototype.successInputUpdateClass = function () {
        this.bcInputDateUtilities.successInputUpdateClass(this.inputDate, this.inputArrow, this.successText, this.calendarBehavior);
    };
    BcInputDateBehavior.prototype.eventFocusOut = function () {
        var _this = this;
        this.inputDate.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUSOUT, function (e) {
            e.preventDefault();
            if (e.target.value) {
                _this.setInputDateValue(e.target.value);
            }
        }, false);
    };
    BcInputDateBehavior.prototype.eventClick = function () {
        this.inputDate.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
            e.preventDefault();
        });
    };
    BcInputDateBehavior.prototype.eventKeyPress = function () {
        var _this = this;
        this.inputDate.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_PRESS, function (e) {
            if (e.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                e.preventDefault();
                var dropdownActive = _this.validateDropdownIsActive();
                if (!dropdownActive) {
                    _this.openDrowndown();
                    _this.validateMobileDropdown();
                }
                else {
                    _this.closeDropdown();
                }
                _this.setInputDateValue(e.target.value);
            }
        });
    };
    BcInputDateBehavior.prototype.handleClick = function (e) {
        var _a;
        var format = (_a = this.calendarBehavior.getMySelf().parentElement) === null || _a === void 0 ? void 0 : _a.parentElement.querySelectorAll(common_constants_1.BcCommonConstants.INPUT_TAG)[common_constants_2.COMMON_CONSTANTS_NUMBERS.N0].getAttribute(bc_date_constants_1.BcDateConstants.FORMAT_DATE);
        var daySelected = this.getDaySelected(this.calendarBehavior.calendarsContainer, format);
        if (daySelected) {
            this.calendarBehavior.setElementsWithFormatDate(daySelected);
        }
        else {
            this.calendarBehavior.setElementsWithFormatDate();
            this.validateFocusoutValue(this.inputDate);
        }
        e.preventDefault();
        this.toggleDropdown();
        this.validateMobileDropdown();
    };
    BcInputDateBehavior.prototype.getDaySelected = function (calendarHtml, format) {
        var daySelected = calendarHtml.getElementsByClassName(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS)[common_constants_2.COMMON_CONSTANTS_NUMBERS.N0];
        if (!daySelected) {
            if (format !== bc_date_constants_2.DateFormate.fullDate) {
                if (this.calendarBehavior.monthsOrYearsContainer) {
                    return this.calendarBehavior.monthsOrYearsContainer.getElementsByClassName(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS)[0];
                }
            }
        }
        return daySelected;
    };
    BcInputDateBehavior.prototype.setInputDateValue = function (e) {
        if (this.placeholderInput) {
            this.placeholderInput.style.display = common_constants_1.BcCommonConstants.NONE;
        }
        this.inputDate.value = e;
        this.emitEvent();
    };
    BcInputDateBehavior.prototype.emitEvent = function () {
        this.value = this.inputDate.value;
        if (this.output) {
            this.output(this.value);
        }
    };
    BcInputDateBehavior.prototype.setValue = function (value) {
        if (this.inputDate) {
            this.inputDate.value = value;
            this.emitEvent();
        }
    };
    BcInputDateBehavior.prototype.setDisabledState = function (isDisabled) {
        this.inputDate.disabled = isDisabled;
    };
    BcInputDateBehavior.prototype.checkIos = function () {
        var userAgent = navigator.userAgent;
        return /iPad|iPhone|iPod/.test(userAgent) || (userAgent.includes(bc_date_constants_1.BcDateConstants.MAC) && bc_date_constants_1.BcDateConstants.ONTOUCHEND in document);
    };
    return BcInputDateBehavior;
}(bc_abstract_dropdown_behavior_1.BcAbstractDropdownBehavior));
exports.BcInputDateBehavior = BcInputDateBehavior;
